/**
 * Generic-calendar daily one-way ranges (cm): Earth surface proxy near USNO
 * toward the Apollo 11 LLR retroreflector.
 *
 * Not a live ephemeris — fixed 365-day lookup for charter RNG seeding.
 * Built from mean lunar distance (384400 km) + e≈0.0549 anomaly term + small seasonal wobble.
 * Index 0 = Jan 1 … index 364 = Dec 31 (non-leap generic year).
 */

export const LUNAR_RANGE_CM_BY_DAY: readonly number[] = [
  36329644000, 36384478531, 36545741047, 36805093375, 37149119079,
  37560018051, 38016528044, 38495025444, 38970748299, 39419078277,
  39816815190, 40143378099, 40381870817, 40519956645, 40550497058,
  40471921275, 40288307577, 40009172164, 39648976487, 39226378552,
  38763266965, 38283627728, 37812302437, 37373702201, 36990543838,
  36682673788, 36466040630, 36351869399, 36346080450, 36448982944,
  36655258840, 36954238222, 37330451685, 37764431209, 38233718046,
  38714025440, 39180495980, 39608988508, 39977327938, 40266453287,
  40461404493, 40552096909, 40533843409, 40407597032, 40179901649,
  39862553171, 39471988856, 39028436325, 38554866346, 38075803604,
  37616057014, 37199435335, 36847514542, 36578520813, 36406386927,
  36340030942, 36382894493, 36532764610, 36781888289, 37117373868,
  37521858453, 37974406811, 38451595225, 38928724162, 39381097013,
  39785298664, 40120407733, 40369079695, 40518444838, 40560774542,
  40493881400, 40321232461, 40051769739, 39699447265, 39282508669,
  38822542678, 38343365438, 37869787511, 37426329399, 37035952079,
  36718868282, 36491496044, 36365608725, 36347725480, 36438773757,
  36634041276, 36923419994, 37291929411, 37720492134, 38186921537,
  38667070401, 39136081047, 39569672255, 39945396337, 40243801290,
  40449437852, 40551659335, 40545172818, 40430313170, 40213025716,
  39904558434, 39520879636, 39081851264, 38610200607, 38130343679,
  37667121166, 37244512385, 36884393846, 36605406668, 36421991506,
  36343640935, 36374408009, 36512696428, 36751343180, 37077989386,
  37475720134, 37923940195, 38399440264, 38877598543, 39333655450,
  39743995462, 40087369720, 40345996123, 40506479928, 40560507223,
  40505275348, 40343637996, 40083957475, 39739671779, 39328598887,
  38872014304, 38393549592, 37917968940, 37469887079, 37072494950,
  36746359075, 36508356796, 36370802521, 36340810183, 36419924946,
  36604043216, 36883625084, 37244188233, 37667057704, 38130332729,
  38610020575, 39081278676, 39519700777, 39902580485, 40210086811,
  40426290855, 40539990470, 40545290216, 40441906577, 40235182647,
  39935811506, 39559282630, 39125079982, 38655673298, 38175354802,
  37708981563, 37280688610, 36912639433, 36623878544, 36429345523,
  36339101574, 36357808644, 36484488073, 36712571261, 37030239739,
  37421037031, 37864720631, 38338309994, 38817276271, 39276812212,
  39693116472, 40044625847, 40313131634, 40484722329, 40550503844,
  40507059977, 40356629267, 40106989116, 39771053136, 39366202598,
  38913386585, 38436037424, 37958857569, 37506540718, 37102493389,
  36767623132, 36519256121, 36370240150, 36328279494, 36395536042,
  36568517386, 36838257622, 37190781536, 37607828124, 38067795993,
  38546861699, 39020213127, 39463334053, 39853273386, 40169833383,
  40396615322, 40521868487, 40539098524, 40447403667, 40251521424,
  39961583316, 39592590354, 39163636417, 38696919737, 38216593667,
  37747516231, 37313963187, 36938371239, 36640176462, 36434808066,
  36332889608, 36339688997, 36454845770, 36672389754, 36981050156,
  37364839070, 37803879193, 38275432911, 38755079457, 39217979211,
  39640159689, 39999756634, 40278145965, 40460907970, 40538573844,
  40507115901, 40368156096, 40128882057, 39801674972, 39403468598,
  38954872580, 38479105457, 38000792611, 37544691373, 37134409301,
  36791181988, 36532773660, 36372557502, 36318823309, 36374348311,
  36536253393, 36796152157, 37140585093, 37551716403, 38008257385,
  38486568584, 38961883642, 39409591487, 39806510487, 40132088600,
  40369467380, 40506354767, 40535661468, 40455867973, 40271103234,
  39990930893, 39629854165, 39206564986, 38742976300, 38263087601,
  37791742435, 37353342224, 36970582961, 36663280209, 36447343219,
  36333951285, 36328974978, 36432672213, 36639674901, 36939266859,
  37315938607, 37750190311, 38219541320, 38699694023, 39165791770,
  39593705738, 39961284114, 40249498925, 40443431146, 40533043080,
  40513698018, 40386400295, 40157743286, 39839568062, 39448350355,
  39004347590, 38530550121, 38051490989, 37591975810, 37175798547,
  36824509666, 36556300429, 36385061112, 36319661875, 36363493546,
  36514292070, 36764255719, 37100448998, 37505472333, 37958362874,
  38435679764, 38912717711, 39364786012, 39768486827, 40102926516,
  40350797333, 40499273468, 40540675062, 40472865795, 40299363493,
  40029157993, 39676245733, 39258905128, 38798750268, 38319611924,
  37846303794, 37403337852, 37013655332, 36697439020, 36471068362,
  36346271471, 36329517943, 36421683918, 36618006711, 36908331388,
  37277636494, 37706811738, 38173647350, 38653983921, 39122963159,
  39556314843, 39931613321, 40229438518, 40434381337, 40535841413,
  40528575897, 40412970893, 40195021461, 39886021239, 39501977756,
  39062783695, 38591187014, 38111613250, 37648900970, 37227015840,
  36867809879, 36589890152, 36407655448, 36330550829, 36362578648,
  36502091330, 36741876675, 37069531233, 37468102451, 37916966328
];

/** Day of year 1–365 (clamped); Dec 31 used for day 366 if ever passed. */
export function lunarRangeCmForDayOfYear(dayOfYear: number): number {
  const d = Math.min(365, Math.max(1, Math.floor(dayOfYear)));
  return LUNAR_RANGE_CM_BY_DAY[d - 1]!;
}

/** Wall-clock local date → table lookup (month/day only; year ignored). */
export function lunarRangeCmForDate(date: Date = new Date()): number {
  const start = Date.UTC(date.getFullYear(), 0, 0);
  const now = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
  const day = Math.round((now - start) / 86400000);
  return lunarRangeCmForDayOfYear(day);
}
